import React from "react";
import { Auth } from "aws-amplify";
import { Navigate, Outlet } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import ApplicationTemplate from "common/layouts/application/index";
import { QuestEditorAllowedDomain, QuestEditorAllowedEmail } from "@quest_editor/constants";

export const AllowedDomainGuard = () => {
  const [isAllowed, setIsAllowed] = React.useState<boolean | null>(null);

  React.useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();

        const email = user?.attributes?.email || "";
        const domain = email.split("@")[1] ?? "";

        // ドメインが許可リストにあるかチェック
        const isDomainAllowed = QuestEditorAllowedDomain.includes(domain);

        // メールアドレスが許可リストにあるかチェック
        const isEmailAllowed = QuestEditorAllowedEmail.includes(email);

        if (isDomainAllowed || isEmailAllowed) {
          setIsAllowed(true);
        } else {
          setIsAllowed(false);
        }
      } catch (error) {
        console.error("Auth error:", error);
        setIsAllowed(false);
      }
    };

    checkAuth();
  }, []);

  // 非同期検証のためローディングを表示
  if (isAllowed === null) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 10,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // 許可されていない場合はTOPへ
  if (!isAllowed) {
    return <Navigate replace to="/" />;
  }

  // 許可されている場合は子ルートを表示
  return (
    <ApplicationTemplate>
      <Outlet />
    </ApplicationTemplate>
  );
};
